import { proxy } from "valtio";
import { devtools } from "valtio/utils";

import type { ModeOfSaleRow } from "./orchestrator";

const ENV_DEV = "dev";
const ENV_RECETTE = "recette";

type CustomerTicketStoreType = {
    printDateTimeDeliveryModesaleItemsLines: boolean;
    printDateTimeDeliveryModesaleMethodPayment: boolean;
    printDateTimeDeliveryModesaleMethodPaymentTva: boolean;
    printDateTimeDeliveryModesaleProviderName: boolean;
    printDateTimeDeliveryModesalePrintNotes: boolean;
    printDateTimeDeliveryModesaleWithoutPrice: boolean;
    customerTicketSalesModes: ModeOfSaleRow[];
    dateTimeDeliveryModeSale: ModeOfSaleRow[];
    customerAddressModeSale: ModeOfSaleRow[];
    saleModes: ModeOfSaleRow[];
};

const CUSTOMER_TICKET_DEFAULTS: CustomerTicketStoreType = {
    printDateTimeDeliveryModesaleItemsLines: false,
    printDateTimeDeliveryModesaleMethodPayment: false,
    printDateTimeDeliveryModesaleMethodPaymentTva: false,
    printDateTimeDeliveryModesaleProviderName: false,
    printDateTimeDeliveryModesalePrintNotes: false,
    printDateTimeDeliveryModesaleWithoutPrice: false,
    customerTicketSalesModes: [],
    dateTimeDeliveryModeSale: [],
    customerAddressModeSale: [],
    saleModes: [],
};

export const customerTicketStore = proxy<CustomerTicketStoreType>({
    ...CUSTOMER_TICKET_DEFAULTS,
});

if (
    process.env.REACT_APP_VERIFY === ENV_DEV ||
    process.env.REACT_APP_VERIFY === ENV_RECETTE
) {
    devtools(customerTicketStore);
}

export function setPrintDateTimeDeliveryModesaleItemsLines(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesaleItemsLines = value;
}
export function setPrintDateTimeDeliveryModesaleMethodPayment(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesaleMethodPayment = value;
}
export function setPrintDateTimeDeliveryModesaleMethodPaymentTva(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesaleMethodPaymentTva = value;
}
export function setPrintDateTimeDeliveryModesaleProviderName(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesaleProviderName = value;
}
export function setPrintDateTimeDeliveryModesalePrintNotes(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesalePrintNotes = value;
}
export function setPrintDateTimeDeliveryModesaleWithoutPrice(
    value: boolean
): void {
    customerTicketStore.printDateTimeDeliveryModesaleWithoutPrice = value;
}
export function setCustomerTicketSalesModes(value: ModeOfSaleRow[]): void {
    customerTicketStore.customerTicketSalesModes = value;
}
export function setDateTimeDeliveryModeSale(value: ModeOfSaleRow[]): void {
    customerTicketStore.dateTimeDeliveryModeSale = value;
}
export function setCustomerAddressModeSale(value: ModeOfSaleRow[]): void {
    customerTicketStore.customerAddressModeSale = value;
}
export function setSaleModes(value: ModeOfSaleRow[]): void {
    customerTicketStore.saleModes = value;
}

export function resetCustomerTicketStore(): void {
    Object.assign(customerTicketStore, CUSTOMER_TICKET_DEFAULTS);
}
